import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemAutomationIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M17 6.38H7C6.65 6.38 6.38 6.66 6.38 7V17C6.38 17.34 6.66 17.62 7 17.62H17C17.34 17.62 17.62 17.34 17.62 17V7C17.62 6.65 17.34 6.38 17 6.38ZM16.38 16.38H7.62V7.62H16.37V16.37L16.38 16.38Z"
        fill={color}
      />
      <path
        d="M23 14.55H21.55V9.45H23C23.41 9.45 23.75 9.11 23.75 8.7C23.75 8.29 23.41 7.95 23 7.95H21.55V5.2C21.55 3.68 20.32 2.45 18.8 2.45H16.05V1C16.05 0.59 15.71 0.25 15.3 0.25C14.89 0.25 14.55 0.59 14.55 1V2.45H9.45V1C9.45 0.59 9.11 0.25 8.7 0.25C8.29 0.25 7.95 0.59 7.95 1V2.45H5.2C3.68 2.45 2.45 3.68 2.45 5.2V7.95H1C0.59 7.95 0.25 8.29 0.25 8.7C0.25 9.11 0.59 9.45 1 9.45H2.45V14.55H1C0.59 14.55 0.25 14.89 0.25 15.3C0.25 15.71 0.59 16.05 1 16.05H2.45V18.8C2.45 20.32 3.68 21.55 5.2 21.55H7.95V23C7.95 23.41 8.29 23.75 8.7 23.75C9.11 23.75 9.45 23.41 9.45 23V21.55H14.55V23C14.55 23.41 14.89 23.75 15.3 23.75C15.71 23.75 16.05 23.41 16.05 23V21.55H18.8C20.32 21.55 21.55 20.32 21.55 18.8V16.05H23C23.41 16.05 23.75 15.71 23.75 15.3C23.75 14.89 23.41 14.55 23 14.55ZM20.05 18.8C20.05 19.49 19.49 20.05 18.8 20.05H5.2C4.51 20.05 3.95 19.49 3.95 18.8V5.2C3.95 4.51 4.51 3.95 5.2 3.95H18.8C19.49 3.95 20.05 4.51 20.05 5.2V18.8Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemAutomationIcon.displayName = 'ItemAutomationIcon';
